import { styled } from '@project44/manifest-ui-deprecated';

const SVG = styled('svg')(() => ({
  display: 'inline-block',
  width: '1em',
  height: '1em',
  strokeWidth: 0,
  stroke: 'currentColor',
  fill: 'currentColor',
}));

interface IconInterface {
  name: string;
  className?: string;
}

const Icon = ({ name, className = '' }: IconInterface) => (
  <SVG className={`icon-${name} ${className}`}>
    <use xlinkHref={`#icon-${name}`} />
  </SVG>
);

export default Icon;
